import { PackageVariantMinusIcon } from './PackageVariantMinusIcon';

/**
 * author: Michael Irigoyen
 * id C204643B-C7FA-48A9-9910-C2258F77E707
 * name package-variant-minus
 * version: 6.6.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/package-variant-minus.svg
 * tags
 */
export const PackageVariantSubtractIcon = PackageVariantMinusIcon;
export default PackageVariantSubtractIcon